import type { PropertyInfo } from '@zg-rentals/clickstream';

export function getPropertyInfo(listingAlias?: string): PropertyInfo {
  return {
    property_info: {
      provider_listing_id: listingAlias ?? null,
    },
  };
}
